import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { SubstitutionDTO } from '../../api/plyca-dtos-v2';
import { Component, OnInit, Optional, ElementRef, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FormConfig, TemplateDef } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';

import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DatePipe } from '@angular/common';
import { PropertyService } from '../../properties/property.service';
import { UserService } from '../../user.service';
import { InboxDTO, ProfileDTO } from '../../api/plyca-dtos';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

// templateUrl: 'customField.edition.template.html'
@Component({
  selector: 'substitution-edition',
  templateUrl: './substitution.edition.template.html',
  providers: [DatePipe]
})
export class SubstitutionEditionComponent
  extends BaseFormComponent<SubstitutionDTO, SubstitutionDTO>
  implements OnInit, OnDestroy {
  private identifier: string;
  private readOnly: boolean;
  private copy: boolean;

  // INI PLP.EXP-9516
  // las suplencias parciales (perfiles buzones y visibilidad) dependen del perfil
  // si un usuario sin permisos edita una  suplencia podría, al no ver esta información
  // en el interface, se borraban los datos de pefiles, etc
  // de tal manera que se considera que un usuario solo puede editar lo que ve, sin borrar la info existente de lo que no ve
  // para ello lo que se hace es que si quien realiza la suplencia no tiene permisos y se está editando una suplencia
  // se sobreesciben los perfiles, buzones y visibilidad, existentes
  private profilesAUX: ProfileDTO[];
  private inboxesAUX: InboxDTO[];
  private exclusiveVisibility = false;
  private applyInboxes = false;
  private applyProfiles = false;
  // FIN PLP.EXP-9516

  @ViewChild('profilesTemplate') profilesTemplate: TemplateRef<any>;
  @ViewChild('inboxesTemplate') inboxesTemplate: TemplateRef<any>;

  constructor(
    elem: ElementRef,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public helpService: HelpService,
    private datePipe: DatePipe,
    private userService: UserService,
    private propertyService: PropertyService,
    @Optional() protected activatedRoute: ActivatedRoute
  ) {
    super(elem);
    this.windowHash = generateRandomIdentifier();
    this.identifier = dialogConfig['id'];
    this.readOnly = dialogConfig['readOnly'];
    this.copy = dialogConfig['copy'];
  }

  getFormSettingURL(): string {
    return 'admin/substitutionsISettings.json';
  }

  getServiceURL(): string {
    return this.configuration.SUBSTITUTIONS_SERVICE_URL;
  }


  getObjectIdentifier(): string {
    if (this.identifier) {
      return this.identifier;
    } else {
      // nuevo contrato
      return 'new';
    }
  }

  loadEndDate() {
    if (this.model.endDate) {
      let end = new Date();
      let dateEnd = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
      this.model.endDate = dateEnd;
    }
  }

  dtoToModel(dto: SubstitutionDTO): Observable<SubstitutionDTO> {

    this.loadConfigParcialSubstitution(dto);

    if (this.copy) {
      dto.state = null;
    }

    // datos de fecha
    this.setDates(dto);
    // Datos de estados
    this.setStates(dto);
    // Datos de causas
    this.setCauses(dto);
    // Datos de tipos
    this.setTypes(dto);

    // en caso de copia, fecha de inicio = a la actual y fecha de fin sin valor
    dto.copy = this.copy;
    if (this.copy) {
      let today = new Date();
      let dateIni = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      dto.initDate = dateIni;

      let dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
      dto.endDate = dateEnd;

    }

    // valor por defecto visibilidad exclusiva
    if (dto.identifier == null) {
      this.subscribe(this.propertyService.getProperty('FraMtoSuplencias.VisibilidadExclusivaPorDefecto', '999'), (value: string) => {
        if (value === '1') {
          dto.exclusiveVisibility = true;
        } else {
          dto.exclusiveVisibility = false;
        }
      });

    }
    return of(dto);
  }

  isNew() {
    return this.getObjectIdentifier() === 'new' ? true : false;
  }

  isSubstitutionParcialProfiles(dto: SubstitutionDTO): boolean {
    return (dto != null
      && dto.context != null
      && dto.context.configurations != null
      && dto.context.configurations.isAllowAsociateProfiles != null
      && dto.context.configurations.isAllowAsociateProfiles.value === true) ? true : false;
  }

  isSubstitutionParcialInboxes(dto: SubstitutionDTO): boolean {
    return (dto != null
      && dto.context != null
      && dto.context.configurations != null
      && dto.context.configurations.isAllowAsociateInboxes != null
      && dto.context.configurations.isAllowAsociateInboxes.value === true) ? true : false;
  }

  isSubstitutionParcialExclusiveVisibility(dto: SubstitutionDTO): boolean {
    return (dto != null
      && dto.context != null
      && dto.context.configurations != null
      && dto.context.configurations.isAllowExclusiveVisibility != null
      && dto.context.configurations.isAllowExclusiveVisibility.value === true) ? true : false;
  }

  loadConfigParcialSubstitution(dto: SubstitutionDTO) {
    if (!this.isSubstitutionParcialProfiles(dto)
      && !this.isNew()) {
      this.profilesAUX = dto.profiles;
      this.applyProfiles = dto.applyProfiles;
    }


    if (!this.isSubstitutionParcialInboxes(dto)
      && !this.isNew()) {
      this.inboxesAUX = dto.userInboxes;
      this.applyInboxes = dto.applyInboxes;
    }

    if (!this.isSubstitutionParcialExclusiveVisibility(dto)
      && !this.isNew()) {
      this.exclusiveVisibility = dto.exclusiveVisibility;
    }
  }

  setDates(model: SubstitutionDTO): void {

    if (model == null || model.identifier == null) {
      let today = new Date();
      let dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
      model.endDate = dateEnd;

      let dateInit = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      model.endDate = dateEnd;
      model.initDate = dateInit;
    }
  }

  setStates(model: SubstitutionDTO): void {
    let stateActive: string = this.translate.instant('Substitution.states.active');
    let stateInactive: string = this.translate.instant('Substitution.states.inactive');
    let stateCreated: string = this.translate.instant('Substitution.states.created');
    let stateFinished: string = this.translate.instant('Substitution.states.finished');

    model.statesSelect =
      [

        {
          'label': stateActive,
          'value': 'ACTIVE'
        },
        {
          'label': stateCreated,
          'value': 'CREATED'
        },
        {
          'label': stateFinished,
          'value': 'FINISHED'
        },
        {
          'label': stateInactive,
          'value': 'INACTIVE'
        }
      ];
  }

  setTypes(model: SubstitutionDTO): void {
    let temporal: string = this.translate.instant('Substitution.types.temporal');
    let definitive: string = this.translate.instant('Substitution.types.definitive');
    let change: string = this.translate.instant('Substitution.types.change');

    model.types =
      [

        {
          'label': temporal,
          'value': 'TEMPORAL'
        },
        {
          'label': definitive,
          'value': 'DEFINITIVE'
        },
        {
          'label': change,
          'value': 'CHANGE'
        }
      ];
  }

  loadType(model: SubstitutionDTO) {
    if (!model.endDate) {
      model.type = 'DEFINITIVE';
    } else {
      model.type = 'TEMPORAL';
    }
  }

  setCauses(model: SubstitutionDTO): void {

    let causeLeave: string = this.translate.instant('Substitution.causes.leave');
    let causeVacation: string = this.translate.instant('Substitution.causes.vacation');
    let causeSubstitution: string = this.translate.instant('Substitution.causes.substitution');
    let causeDelegation: string = this.translate.instant('Substitution.causes.delegation');
    let causeOthers: string = this.translate.instant('Substitution.causes.others');
    model.causes = [];
    model.causes = [
      {
        'label': causeLeave,
        'value': 'LEAVE'
      },
      {
        'label': causeDelegation,
        'value': 'DELEGATION'
      },
      {
        'label': causeOthers,
        'value': 'OTHERS'
      },
      {
        'label': causeSubstitution,
        'value': 'SUBSTITUTION'
      },
      {
        'label': causeVacation,
        'value': 'VACATION'
      }
    ];
  }

  modelToDTO(model: SubstitutionDTO): SubstitutionDTO {
    return model;
  }

  getTitle(model: SubstitutionDTO): string {
    if (model) {
      return model.identifier;
    } else {
      return 'Nuevo grupo';
    }
  }

  // getProjectId(): string {
  //   return this.model.dto.project.identifier;
  // }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Substitution.title';
    headerInfo.titleIcon = 'fas fa-people-carry';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.searchTags = [HelpType.EDIT_SUBSTITUTIONS];
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readOnly;

    let profilesTDef = new TemplateDef();
    profilesTDef.identifier = 'profilesTemplate';
    profilesTDef.template = this.profilesTemplate;
    formConfig.templates.push(profilesTDef);

    let inboxesTDef = new TemplateDef();
    inboxesTDef.identifier = 'inboxesTemplate';
    inboxesTDef.template = this.inboxesTemplate;
    formConfig.templates.push(inboxesTDef);

    formConfig.functions.push({
      identifier: 'clearInboxes',
      fn: this.clearInboxes
    });

    formConfig.functions.push({
      identifier: 'clearProfiles',
      fn: this.clearProfiles
    });

    formConfig.functions.push({
      identifier: 'reloadSignatureComment',
      fn: this.reloadSignatureComment
    });
    return of(formConfig);
  }



  reloadSignatureComment() {
    if (this.model.signatureCommentBBDD) {
      this.model.signatureComment = this.model.signatureCommentBBDD;
    }
  }

  clearInboxes() {
    if (!this.model.applyInboxes) {
      this.model.userInboxes = [];
    }
  }

  clearProfiles() {
    if (!this.model.applyProfiles) {
      this.model.profiles = [];
    }
  }

  setParcialSubstitutionData(dto: SubstitutionDTO) {
    if (!this.isSubstitutionParcialProfiles(dto)
      && !this.isNew()) {
      dto.profiles = this.profilesAUX;
      dto.applyProfiles = this.applyProfiles;
    }

    if (!this.isSubstitutionParcialInboxes(dto)
      && !this.isNew()) {
      dto.userInboxes = this.inboxesAUX;
      dto.applyInboxes = this.applyInboxes;
    }

    if (!this.isSubstitutionParcialExclusiveVisibility(dto)
      && !this.isNew()) {
      dto.exclusiveVisibility = this.exclusiveVisibility;
    }
  }

  initHeaderActions() {

    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.readOnly) {
      this.subscribe(this.headerActionsService.addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),
        () => {

          if (this.copy) {
            this.model.identifier = null;
          }

          this.setParcialSubstitutionData(this.model);

          this.subscribe(this.save(),
            (result) => {
              this.ref.close();
            }
          );
        });
      // this.headerActionsService.addWindowDivider(this.windowHash);
      // this.addBackAction();
    }

  }


}
